import { useFlagProtection } from "hooks/useFlagProtection"
import { Toast } from "primereact/toast"
import { useEffect, useRef, useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import { INTEGRACIONES } from "routes/RoutePaths"
import imgIntergration from "../../../assets/img-scan-integraciones.svg"

const ToastIntegraciones = ({
  isVisible,
  handleCloseToast,
}: {
  isVisible: boolean
  handleCloseToast: () => void
}) => {
  const isInterno = sessionStorage.getItem("isUserInterno") === "true"
  const flagIntegracionesUsuariosInternos = useFlagProtection(
    isInterno ? "integraciones_internos" : "integraciones_all_users"
  )
  const { t } = useTranslation()
  const [shouldShowToast, setShouldShowToast] = useState(true)
  const toast = useRef<Toast>(null)
  const history = useHistory()
  const { pathname } = useLocation()

  useEffect(() => {
    const shouldShow = localStorage.getItem("showToastIntegration") !== "false"
    setShouldShowToast(shouldShow)
  }, [])

  useEffect(() => {
    if (isVisible && shouldShowToast && toast.current) {
      if (pathname.includes(INTEGRACIONES)) {
        toast.current.clear()
        setShouldShowToast(false)
        localStorage.setItem("showToastIntegration", "false")
        return
      }

      toast.current.clear()

      toast.current.show({
        detail: (
          <div className='tw-w-full tw-flex tw-flex-row'>
            <div className='!tw-w-14 !tw-h-14 tw-mr-5'>
              <img
                src={imgIntergration}
                alt={`${t("integracion.logo")}`}
              />
            </div>
            <div className='tw-flex tw-flex-col tw-w-95'>
              <span className='tw-text-base tw-font-medium tw-w-full tw-text-start'>
                {t("integracion.toast.title")}
              </span>
              <span className='!tw-text-sm tw-w-full tw-text-start'>
                <Trans
                  i18nKey='integracion.toast.text'
                  components={[
                    <span
                      className='tw-font-medium tw-contents'
                      key='0'
                    />,
                  ]}
                />
              </span>
            </div>
          </div>
        ),
        sticky: true,
        className:
          "!tw-text-white [&>:nth-child(1)]:!tw-border-none !tw-bg-primary [&>*:first-child>*:nth-child(3)]:!tw-text-white",
      })

      setShouldShowToast(false)
    }
  }, [isVisible, shouldShowToast, pathname, t])

  const handleToastHide = () => {
    handleCloseToast()
    localStorage.setItem("showToastIntegration", "false")
    setShouldShowToast(false)
  }

  if (!flagIntegracionesUsuariosInternos) {
    return null
  }
  return (
    <div>
      <Toast
        ref={toast}
        className='tw-w-140 tw-cursor-pointer'
        position='bottom-right'
        onClick={() => {
          toast.current && toast.current.clear()
          history.push(INTEGRACIONES)
        }}
        onHide={handleToastHide}
      />
    </div>
  )
}

export default ToastIntegraciones
